import { useLabels } from "~/hooks/useLabels";

import type { ReactNode } from "react";
import type { I18nContextValue } from "./context";

export interface TranslationProps {
  children: (t: I18nContextValue["t"]) => ReactNode;
}

export function Translation({ children }: TranslationProps) {
  const { t } = useLabels();
  return <>{children(t) ?? null}</>;
}
